import RingBuffer from './ring-buffer';

// * Use Factory Pattern!

export const Log = () => {
  console.log('[Log] Factory');
  if (process.env.VITE_APP_CONSOLE === '0') {
    console.log('[Log] Disabled');
    window['console']['log'] = () => undefined;
  }
  const messages = new RingBuffer<unknown[]>(100);
  return {
    messages,
    log(...args: unknown[]) {
      const preservedConsoleLog = console.log;
      preservedConsoleLog.apply(console, args as []);
      if (process.env.VITE_APP_CONSOLE_MESSAGES === '1') {
        messages.push(args);
      }
    },
  };
};

export type Log = ReturnType<typeof Log>;
